@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div cdkDrag class="popup_main_div add_edit_allowance" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>{{ dialogTitle }}</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYEE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYEE),
            }"
            class="example"
            appearance="outline"
            fxFlex="46"
            class="pr-1"
          >
            <mat-label>Payee</mat-label>
            <input
              [(ngModel)]="PAYEE"
              name="PAYEE"
              (ngModelChange)="changeForControl('PAYEE', $event)"
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.PAYEE?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.PAYEE?.COPYVALUE) : ''
                  )
                "
              >
                <input id="myInput" readonly disabled value="{{ toolTipList?.PAYEE?.COPYVALUE }}" />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PRICEFROM),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PRICEFROM),
            }"
            appearance="outline"
            fxFlex="17"
            class="pr-1"
          >
            <mat-label>Amount</mat-label>
            <!-- Removed (focusout)="amoutCal()" from below input -->
            <input
              style="text-align: right"
              [formControl]="amountValue"
              type="text"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              [(ngModel)]="AMOUNT"
              name="AMOUNT"
              (blur)="changeForControl('PRICEFROM', $event)"
              matInput
              matTooltip="{{ toolTipList ? toolTipList?.AMOUNT?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
              [leadZero]="true"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.AMOUNT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.AMOUNT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            fxFlex="20"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYMENTDATE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYMENTDATE),
            }"
          >
            <mat-label>Payment Date</mat-label>
            <!-- Removed (focusout)="amoutCal()" from below input -->
            <input
              matInput
              placeholder="Choose a To date"
              [(ngModel)]="PAYMENTDATE"
              name="PAYMENTDATE"
              (ngModelChange)="getPaymentDate(PAYMENTDATE); changeForControl('PAYMENTDATE', $event)"
              [matDatepicker]="toDate"
            />
            <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
            <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.AMOUNT?.PAYMENTDATE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.AMOUNT?.PAYMENTDATE}}"><mat-icon >file_copy</mat-icon></div> -->
          </mat-form-field>

          <mat-form-field
            class="example"
            appearance="outline"
            fxFlex="17"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYMENTTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYMENTTYPE),
            }"
          >
            <mat-label>Payment Type</mat-label>
            <mat-select
              [(ngModel)]="PAYMENTTYPE"
              name="PAYMENTTYPE"
              (ngModelChange)="getPaymentType(PAYMENTTYPE); changeForControl('PAYMENTTYPE', $event)"
            >
              <mat-option value="BPay">BPay</mat-option>
              <mat-option value="EFT">EFT</mat-option>
              <mat-option value="Foreign EFT">Foreign EFT</mat-option>
              <mat-option value="Other">Other</mat-option>
            </mat-select>
            <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.PAYEE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.PAYEE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
          </mat-form-field>
        </div>

        @if (PAYMENTTYPE == 'BPay') {
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field
              class="example"
              appearance="outline"
              fxFlex="50"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.BPAYBILLERCODE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BPAYBILLERCODE),
              }"
            >
              <mat-label>Biller Code</mat-label>
              <input
                [(ngModel)]="BPAYBILLERCODE"
                (ngModelChange)="changeForControl('BPAYBILLERCODE', $event)"
                name="BPAYBILLERCODE"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.BPAYBILLERCODE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.PAYEE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.PAYEE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.BPAYREFERENCE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BPAYREFERENCE),
              }"
              class="example"
              appearance="outline"
              fxFlex="50"
              class="pr-1"
            >
              <mat-label>Reference</mat-label>
              <input
                [(ngModel)]="BPAYREFERENCE"
                name="BPAYREFERENCE"
                (ngModelChange)="changeForControl('BPAYREFERENCE', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.BPAYREFERENCE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.PAYEE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.PAYEE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
          </div>
        }
        @if (PAYMENTTYPE == 'EFT') {
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field
              class="example"
              appearance="outline"
              fxFlex="25"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCOUNTNAME),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCOUNTNAME),
              }"
            >
              <mat-label>Account Name</mat-label>
              <input
                [(ngModel)]="ACCOUNTNAME"
                (ngModelChange)="changeForControl('ACCOUNTNAME', $event)"
                name="ACCOUNTNAME"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.BPAYBILLERCODE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ACCOUNTNAME?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.PAYEE?.COPYVALUE }}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.BSB),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BSB),
              }"
              class="example"
              appearance="outline"
              fxFlex="25"
              class="pr-1"
            >
              <mat-label>BSB</mat-label>
              <input
                [(ngModel)]="BSB"
                name="BSB"
                (ngModelChange)="changeForControl('BSB', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.BSB?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.BSB?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.BSB?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.ACCOUNTNUMBER),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACCOUNTNUMBER),
              }"
              class="example"
              appearance="outline"
              fxFlex="25"
              class="pr-1"
            >
              <mat-label>Account Number</mat-label>
              <input
                [(ngModel)]="ACCOUNTNUMBER"
                name="ACCOUNTNUMBER"
                (ngModelChange)="changeForControl('ACCOUNTNUMBER', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.ACCOUNTNUMBER?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ACCOUNTNUMBER?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.ACCOUNTNUMBER?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.EFTREFERENCE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.EFTREFERENCE),
              }"
              class="example"
              appearance="outline"
              fxFlex="25"
              class="pr-1"
            >
              <mat-label>EFT Reference</mat-label>
              <input
                [(ngModel)]="EFTREFERENCE"
                name="EFTREFERENCE"
                (ngModelChange)="changeForControl('EFTREFERENCE', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.EFTREFERENCE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.EFTREFERENCE?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.EFTREFERENCE?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
          </div>
        }
        @if (PAYMENTTYPE == 'Foreign EFT') {
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOREIGNEFTSWIFTCODE),
                'has-warning': $safeNavigationMigration(
                  errorWarningData.Warning?.FOREIGNEFTSWIFTCODE
                ),
              }"
            >
              <mat-label>Swift Code</mat-label>
              <input
                [(ngModel)]="FOREIGNEFTSWIFTCODE"
                (ngModelChange)="changeForControl('FOREIGNEFTSWIFTCODE ', $event)"
                name="FOREIGNEFTSWIFTCODE "
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.FOREIGNEFTSWIFTCODE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTSWIFTCODE ?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTSWIFTCODE ?.COPYVALUE }}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOREIGNEFTIBAN),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOREIGNEFTIBAN),
              }"
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
            >
              <mat-label>IBAN</mat-label>
              <input
                [(ngModel)]="FOREIGNEFTIBAN"
                name="FOREIGNEFTIBAN"
                (ngModelChange)="changeForControl('FOREIGNEFTIBAN', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.FOREIGNEFTIBAN?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTIBAN?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTIBAN?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOREIGNEFTBANKNAME),
                'has-warning': $safeNavigationMigration(
                  errorWarningData.Warning?.FOREIGNEFTBANKNAME
                ),
              }"
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
            >
              <mat-label>Bank Name</mat-label>
              <input
                [(ngModel)]="FOREIGNEFTBANKNAME"
                name="FOREIGNEFTBANKNAME"
                (ngModelChange)="changeForControl('FOREIGNEFTBANKNAME', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.FOREIGNEFTBANKNAME?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTBANKNAME?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTBANKNAME?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
          </div>
        }
        @if (PAYMENTTYPE == 'Foreign EFT') {
          <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOREIGNEFTCOUNTRY),
                'has-warning': $safeNavigationMigration(
                  errorWarningData.Warning?.FOREIGNEFTCOUNTRY
                ),
              }"
            >
              <mat-label>Country</mat-label>
              <input
                [(ngModel)]="FOREIGNEFTCOUNTRY"
                (ngModelChange)="changeForControl('FOREIGNEFTCOUNTRY ', $event)"
                name="FOREIGNEFTCOUNTRY "
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.FOREIGNEFTCOUNTRY?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTCOUNTRY ?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTCOUNTRY ?.COPYVALUE }}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.FOREIGNEFTAMOUNT),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FOREIGNEFTAMOUNT),
              }"
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
            >
              <mat-label>Amount</mat-label>
              <input
                currencyMask
                [(ngModel)]="FOREIGNEFTAMOUNT"
                name="FOREIGNEFTAMOUNT"
                (ngModelChange)="changeForControl('FOREIGNEFTAMOUNT', $event)"
                matInput
                matTooltip="{{ toolTipList ? toolTipList?.FOREIGNEFTAMOUNT?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTAMOUNT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTAMOUNT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(
                  errorWarningData.Error?.FOREIGNEFTCONVERSIONDETAILS
                ),
                'has-warning': $safeNavigationMigration(
                  errorWarningData.Warning?.FOREIGNEFTCONVERSIONDETAILS
                ),
              }"
              class="example"
              appearance="outline"
              fxFlex="33.3"
              class="pr-1"
            >
              <mat-label>Conversion Details</mat-label>
              <input
                [(ngModel)]="FOREIGNEFTCONVERSIONDETAILS"
                name="FOREIGNEFTCONVERSIONDETAILS"
                (ngModelChange)="changeForControl('FOREIGNEFTCONVERSIONDETAILS', $event)"
                matInput
                matTooltip="{{
                  toolTipList ? toolTipList?.FOREIGNEFTCONVERSIONDETAILS?.HOVER : ''
                }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <!-- <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.FOREIGNEFTCONVERSIONDETAILS?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.FOREIGNEFTCONVERSIONDETAILS?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div> -->
            </mat-form-field>
          </div>
        }
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    @if (action === 'new') {
      <button matButton="filled" (click)="saveCheque()" [disabled]="isspiner">
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
    }
    @if (action === 'edit') {
      <button matButton="filled" (click)="saveCheque()" [disabled]="isspiner">
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Update
      </button>
    }
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
